// src/components/KitCard/KitCard.tsx

import React, { useState } from 'react';
import styles from './KitCard.module.css';

interface Kit {
  id: string;
  name: string;
  category: string;
  title: string;
  description: string;
  audioUrl?: string;
  imageUrl: string;
  price?: string;
}

interface KitCardProps {
  kit: Kit;
}

const KitCard: React.FC<KitCardProps> = ({ kit }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <div className={`${styles.cardContainer} ${isFlipped ? styles.isFlipped : ''}`}>
      <div className={styles.cardInner}>
        {/* Frente do Card */}
        <div className={styles.cardFace} id={styles.cardFront}>
          <div className={styles.cardHeader}>
            <button className={styles.flipButton} onClick={() => setIsFlipped(true)} aria-label="Ver detalhes">
              <span className="material-symbols-outlined notranslate" translate="no">sync</span>
            </button>
          </div>
          <div className={styles.kitArtworkWrapper}>
            <img src={kit.imageUrl} alt={kit.title} className={styles.kitArtwork} />
          </div>
          <div className={styles.kitInfoFront}>
            <h3>{kit.title}</h3>
            <div className={styles.cardActions}>
              <button className={styles.actionButton} aria-label={`Play ${kit.title}`}>
                <span className="material-symbols-outlined notranslate" translate="no">play_arrow</span>
              </button>
              <button className={styles.actionButton} aria-label={`Comprar ${kit.title}`}>
                <span className="material-symbols-outlined notranslate" translate="no">add_shopping_cart</span>
              </button>
            </div>
          </div>
        </div>

        {/* Verso do Card */}
        <div className={styles.cardFace} id={styles.cardBack}>
          <div className={styles.cardHeader}>
             <button className={styles.flipButton} onClick={() => setIsFlipped(false)} aria-label="Voltar para a imagem">
              <span className="material-symbols-outlined notranslate" translate="no">sync</span>
            </button>
          </div>
          <div className={styles.kitDescriptionContent}>
            <h3 className={styles.kitTitle}>{kit.title}</h3>
            <p>{kit.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KitCard;